import { GuaranteeSeals } from '../components/GuaranteeSeals';
import { Icon } from '../components/Icon';
import { PageHero } from '../components/PageHero';
import { Reveal } from '../components/Reveal';
import { GUARANTEES, WHY, buildWhatsAppUrl } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

export function WhyChoosePage() {
  useDocumentMeta({
    title: 'Por qué elegir Indemniza | Corporación Indemniza',
    description: 'Conoce las razones para elegir una defensa especializada en indemnizaciones y reparación de daños.',
    canonicalPath: '/por-que-elegirnos',
  });

  return (
    <div className="why-page">
      <PageHero
        image={WHY.heroImage}
        position={WHY.heroPosition}
        mobilePosition={WHY.heroMobilePosition}
        eyebrow="Por qué elegirnos"
        title="La diferencia está en la especialización"
        subtitle="No somos generalistas. Somos el equipo que se dedica exclusivamente a que recibas la indemnización que te corresponde."
      />

      <section className="why-reasons" aria-labelledby="why-reasons-title">
        <div className="site-container">
          <Reveal as="header" className="section-intro section-intro--compact">
            <p className="eyebrow">Lo que nos diferencia</p>
            <h2 id="why-reasons-title">Seis razones para elegirnos</h2>
          </Reveal>
          <div className="reasons-grid">
            {WHY.reasons.map((reason, index) => (
              <Reveal as="article" className="reason-card" delay={(index % 3) * 70} key={reason.title}>
                <span><Icon name={reason.icon} size={21} /></span>
                <h3>{reason.title}</h3>
                <p>{reason.description}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="why-seals" aria-labelledby="why-seals-title">
        <div className="site-container">
          <Reveal as="header" className="section-intro section-intro--light section-intro--compact">
            <p className="eyebrow">Nuestras garantías</p>
            <h2 id="why-seals-title">Sellos de confianza</h2>
            <p>El compromiso que respalda cada caso que asumimos.</p>
          </Reveal>
          <Reveal delay={80}><GuaranteeSeals items={GUARANTEES} /></Reveal>
        </div>
      </section>

      <section className="why-comparison" aria-labelledby="comparison-title">
        <div className="site-container">
          <Reveal as="header" className="section-intro section-intro--compact">
            <p className="eyebrow">La diferencia en la práctica</p>
            <h2 id="comparison-title">Con Corporación Indemniza vs. sin<br />asesoría especializada</h2>
          </Reveal>
          <Reveal className="comparison-table" delay={60}>
            <div className="comparison-table__head"><div>Con Corporación Indemniza</div><div>Sin asesoría especializada</div></div>
            {WHY.comparison.map((row) => (
              <div className="comparison-table__row" key={row.withUs}>
                <div><span className="status status--yes"><Icon name="check" size={13} /></span>{row.withUs}</div>
                <div><span className="status status--no"><Icon name="x" size={11} /></span>{row.withoutUs}</div>
              </div>
            ))}
          </Reveal>
        </div>
      </section>

      <section className="why-cta" aria-labelledby="why-cta-title">
        <Reveal className="site-container why-cta__content">
          <h2 id="why-cta-title">Hablemos de tu caso</h2>
          <p>Cuéntanos qué pasó y te decimos cómo podemos ayudarte.</p>
          <a href={buildWhatsAppUrl()} target="_blank" rel="noopener noreferrer"><Icon name="whatsapp" size={19} /> Escríbenos por WhatsApp</a>
        </Reveal>
      </section>
    </div>
  );
}
